import { createReducer, on } from '@ngrx/store';
import { INotificationItem, NotificationListMetadata } from '../models/notification.models';
import * as notificationActions from './notification.actions';

// ─── State Interface ─────────────────────────────────────────────────────────

export interface NotificationState {
  notifications: INotificationItem[];
  unreadCount: number;
  loading: boolean;
  loaded: boolean;
  metadata: NotificationListMetadata | null;
}

// ─── Initial State ───────────────────────────────────────────────────────────

export const initialNotificationState: NotificationState = {
  notifications: [],
  unreadCount: 0,
  loading: false,
  loaded: false,
  metadata: null,
};

// ─── Reducer ─────────────────────────────────────────────────────────────────

export const notificationReducer = createReducer(
  initialNotificationState,

  // ── Unread count (SSE) ──
  on(notificationActions.SetUnreadCount, (state, { count }) => ({
    ...state,
    unreadCount: count,
  })),

  on(notificationActions.IncrementUnreadCount, (state) => ({
    ...state,
    unreadCount: state.unreadCount + 1,
  })),

  // ── Load notifications ──
  on(notificationActions.LoadNotifications, (state) => ({
    ...state,
    loading: true,
  })),

  on(notificationActions.LoadNotificationsSuccess, (state, { notifications, metadata }) => ({
    ...state,
    notifications,
    metadata,
    loading: false,
    loaded: true,
  })),

  on(notificationActions.LoadNotificationsError, (state) => ({
    ...state,
    loading: false,
  })),

  // ── Mark as read ──
  on(notificationActions.MarkAsReadSuccess, (state, { id }) => ({
    ...state,
    notifications: state.notifications.map((n) =>
      n.id === id ? { ...n, is_read: true } : n
    ),
    unreadCount: Math.max(0, state.unreadCount - 1),
  })),

  // ── Mark all as read ──
  on(notificationActions.MarkAllAsReadSuccess, (state) => ({
    ...state,
    notifications: state.notifications.map((n) => ({ ...n, is_read: true })),
    unreadCount: 0,
  })),

  // ── New notification from SSE ──
  on(notificationActions.NewNotificationReceived, (state, { notification }) => ({
    ...state,
    notifications: state.loaded
      ? [notification, ...state.notifications]
      : state.notifications,
  })),
);
